module.exports = __webpack_public_path__ + "static/media/red-house.c6da361f.svg";